(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@ant-design/icons"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@ant-design/icons"], factory);
	else if(typeof exports === 'object')
		exports["fangzhouComDef"] = factory(require("react"), require("@ant-design/icons"));
	else
		root["fangzhouComDef"] = factory(root["React"], root["icons"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__4012__, __WEBPACK_EXTERNAL_MODULE__5423__) {
return 